import {
  ExamTitle,
  HandWriting,
  HandWritingBox,
  Line,
  Objective,
  ObjectiveBox,
  ObjectiveTitle,
  TitleBox,
} from "./LegacyStyles";

export const LegacyExamHeader = ({
  title,
  objectiveIndex,
  objective,
  zoomFactor,
}: {
  title: string;
  objectiveIndex: number;
  objective: string;
  zoomFactor: number;
}) => {
  return (
    <>
      <TitleBox zoomfactor={zoomFactor}>
        <ExamTitle zoomfactor={zoomFactor}>{title}</ExamTitle>
        <HandWritingBox zoomfactor={zoomFactor}>
          <HandWriting zoomfactor={zoomFactor}>Name:</HandWriting>
          <Line />
        </HandWritingBox>
      </TitleBox>
      <ObjectiveBox zoomfactor={zoomFactor}>
        <ObjectiveTitle zoomfactor={zoomFactor}>Kompetenz {objectiveIndex}</ObjectiveTitle>
        <Objective zoomfactor={zoomFactor}>{objective}</Objective>
      </ObjectiveBox>
    </>
  );
};

export default LegacyExamHeader;
